export default __webpack_public_path__ + "static/media/TypeScript.fa65c4bd.png";